import type { HttpErrorType } from 'types/errors'

import { parseServerError } from '@disco/utils/captureError'

/**
 * Converts server login errors into user-friendly error messages.
 *
 * Processes error codes from HTTP errors and maps them to customized messages
 * for specific error types. Falls back to generic server error parsing when
 * no specific message is defined.
 *
 * @param errorOrigin - HTTP error object containing code and body information
 * @returns User-friendly error message string
 */
export const explainServerLoginErrorAsString = (
  errorOrigin: HttpErrorType,
): string => {
  const error = { ...errorOrigin }
  error.code = error.code?.replace(/(\['|'\])/g, '')

  // Add new error handling as needed.
  // Now contains the minimum required errors for the task https://app.asana.com/0/1106437503322489/1187173489005785/f
  const customMessages = {
    NEW_PASSWORD_TOO_WEAK:
      'Sorry! The password you entered doesn’t meet our minimum security requirements.',
    OLD_PASSWORD_INCORRECT: 'The current password is not correct.',
  } as const

  return (
    (error.code && customMessages[error.code]) || parseServerError(error.body)
  )
}
